import React from "react";
import "./WhatIDo.css";
import expertise from "../../../assets/professional-success.png";
import result from "../../../assets/goal.png";
import process from "../../../assets/management.png";
const WhatIDo = () => {
  return (
    <div className="whatIDo-container flex flex-col   bg-gradient-to-b from-white to-blue-100  items-center p-12 min-h-screen">
      {/* Heading */}
      <div className="whatIDo-heading mb-6">
        <h1 className="text-5xl font-extrabold text-gray-800">Let's Talk Business</h1>
      </div>

      {/* Sub-heading */}
      <div className="whatIDo-subHeading mb-12">
        <h2 className="text-3xl text-gray-600 italic">Code to solve Problems</h2>
      </div>

      {/* Content Section */}
      {/* <div className="whatIDo-content flex justify-between space-x-6 w-full"> */}
      <div className="whatIDo-content flex flex-col sm:flex-row  sm:flex-nowrap justify-between flex-wrap gap-6 w-full">

        {/* Content Block 1 */}
        <div className="whatIDo-content-block flex flex-col items-start justify-start p-6 rounded-lg w-full sm:w-1/3 min-h-52 ">
          <div className="whatIDo-content-Image w-16 h-16 bg-gray-200 rounded-full mb-4"><img src={expertise} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} /></div>
          <h3 className="text-3xl font-bold text-gray-800 mb-2">My Expertise</h3>
          <ul className="text-lg font-bold text-gray-700 list-disc pl-4 space-y-1">
            <li>Design Strategy</li>
            <li>Front-end Development</li>
            <li>Back-end Development</li>
            <li>Fullstack Development</li>
            <li>Cloud Solutions</li>
            <li>API Development & Integration</li> 
            <li>Database Design & Optimization</li> 
            <li>AI-Powered Solutions & Chatbot Integration</li> 
          </ul>
        </div>

        {/* Content Block 2 */}
        <div className="whatIDo-content-block flex flex-col items-start justify-start p-6 rounded-lg w-full sm:w-1/3 min-h-52">
          <div className="whatIDo-content-Image w-16 h-16 bg-gray-200 rounded-full mb-4"><img src={result} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} /></div>
          <h3 className="text-3xl font-bold text-gray-800 mb-2">The Results You’ll See</h3>
          <ul className="text-lg text-gray-700 font-bold list-disc pl-4 space-y-1">
            <li>Clean and Functional: Intuitive designs that prioritize functionality.</li>
            <li>Device and User Friendly: Seamless experiences across all devices.</li>
            <li>Efficient and Maintainable: Code that is easy to manage and scale.</li>
            <li>Scalable and Secure: Future-proof solutions with strong security protocols.</li>
          </ul>
        </div>

        {/* Content Block 3 */}
        {/* <div className="whatIDo-content-block flex flex-col items-start justify-start bg-white p-6 rounded-lg shadow-lg w-1/3 min-h-52 border border-gray-200 transition-transform hover:scale-105 hover:shadow-xl"> */} 
        <div className="whatIDo-content-block flex flex-col items-start justify-start p-6 rounded-lg w-full sm:w-1/3 min-h-52">
          <div className="whatIDo-content-Image w-16 h-16 bg-gray-200 rounded-full mb-4"><img src={process} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} /></div>
          <h3 className="text-3xl font-bold text-gray-800 mb-2">How I Work</h3>
          <ul className="text-lg font-bold text-gray-700 list-disc pl-4 space-y-1">
            <li>Understand & Analyze: Grasp client needs and project requirements thoroughly.</li>
            <li>Plan & Design: Create scalable architecture and intuitive UI/UX.</li>
            <li>Develop & Test: Write clean, optimized code with robust testing.</li>
            <li>Deploy & Maintain: Ensure smooth deployment and hassle-free maintenance.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WhatIDo;
